"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.logPlugin = void 0;
var _helperCompilationTargets = require("@babel/helper-compilation-targets");
var _plugins = require("@babel/compat-data/plugins");
var logPlugin = function logPlugin(item, targetVersions, list) {
  var filteredList = (0, _helperCompilationTargets.getInclusionReasons)(item, targetVersions, list);
  var support = list[item];
  {
    if (item.startsWith("transform-")) {
      var proposalName = "proposal-".concat(item.slice(10));
      if (proposalName === "proposal-dynamic-import" || Object.prototype.hasOwnProperty.call(_plugins, proposalName)) {
        item = proposalName;
      }
    }
  }
  if (!support) {
    console.log("  ".concat(item));
    return;
  }
  var formattedTargets = "{";
  var first = true;
  for (var _i = 0, _Object$keys = Object.keys(filteredList); _i < _Object$keys.length; _i++) {
    var target = _Object$keys[_i];
    if (!first) formattedTargets += ",";
    first = false;
    formattedTargets += " ".concat(target);
    if (support[target]) formattedTargets += " < ".concat(support[target]);
  }
  formattedTargets += " }";
  console.log("  ".concat(item, " ").concat(formattedTargets));
};
exports.logPlugin = logPlugin;